import { render, staticRenderFns } from "./dx_order_zid.vue?vue&type=template&id=4fca2dbe&scoped=true&"
import script from "./dx_order_zid.vue?vue&type=script&lang=js&"
export * from "./dx_order_zid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fca2dbe",
  null
  
)

component.options.__file = "dx_order_zid.vue"
export default component.exports